import { ResultsMode } from 'interfaces/experimentResults';
import { exportFeatures } from 'utils/exports';

import { exportFeaturesForGroups, FeaturesExportGroup } from './exportFeaturesForGroups';

type FeaturesExportOptions = Parameters<typeof exportFeatures>[0];

export interface FeaturesExportRun {
  studyId: string;
  context: FeaturesExportOptions['context'] & {
    skipPreloadingStudyStains?: boolean;
    labId?: string;
    studyId?: string;
  };
  resultsMode?: ResultsMode;
  orchestrationId?: string;
  hideExcluded?: boolean;
  casesParams?: FeaturesExportOptions['casesParams'];
  groups?: FeaturesExportGroup[];
  highlightedOnly?: boolean;
}

// The request the Features form and the Workflow's no-configuration download both send.
export const runFeaturesExport =
  ({
    studyId,
    context,
    resultsMode,
    orchestrationId,
    hideExcluded,
    casesParams,
    groups,
    highlightedOnly,
  }: FeaturesExportRun) =>
  (signal: AbortSignal) => {
    if ((groups?.length ?? 0) > 1) {
      return exportFeaturesForGroups({
        studyId,
        context,
        hideExcluded,
        groups: groups as FeaturesExportGroup[],
        highlightedOnly,
        signal,
      });
    }
    const [onlyGroup] = groups ?? [];
    const resolvedMode = onlyGroup?.resultsMode ?? resultsMode;
    const resolvedOrchestrationId = onlyGroup?.orchestrationId ?? orchestrationId;
    const resolvedCasesParams = onlyGroup?.casesParams ?? casesParams;
    return exportFeatures({
      studyId,
      context: onlyGroup ? { ...context, orchestrationId: onlyGroup.orchestrationId } : context,
      resultsMode: resolvedMode,
      ...(resolvedMode === ResultsMode.Manual && { orchestrationId: resolvedOrchestrationId }),
      hideExcluded,
      ...(resolvedCasesParams && { casesParams: resolvedCasesParams }),
      ...(highlightedOnly && { highlightedOnly }),
      signal,
    });
  };
